import { inject } from '@angular/core';
import { Observable, map, take } from 'rxjs';

import { CanActivateFn, CanMatchFn } from '@shared/models/guard';
import { AppFacade } from '@shared/state/facades';

export const canActivateAppStatusGuard: CanActivateFn =
  (): Observable<boolean> => isAppOnline();

export const canMatchAppStatusGuard: CanMatchFn = (): Observable<boolean> =>
  isAppOnline();

const isAppOnline = (): Observable<boolean> => {
  const appFacade = inject(AppFacade);

  return appFacade.query.isAppOnline$.pipe(
    take(1),
    map((isAppOnline) => !!isAppOnline)
  );
};
